import { store } from 'app/shared/store/store';
import { EnergyProductsResponse } from 'app/shared/models/product-response.model';
import { ProductSearchRequestModel } from 'app/shared/models/productSearchRequestModel';
import { ResponseError } from 'app/shared/models/response-error.error';
import { getHeaders } from 'app/shared/utilities/helper-functions';

class EnergyProductSearchApiService {
  private energyProductSearchPath = '/products/search';

  public getEnergyProducts = async (request: ProductSearchRequestModel): Promise<EnergyProductsResponse> => {
    const configData = store.get('configData');
    const init = {
      method: 'POST',
      body: JSON.stringify({
        ...request
      }),
      headers: getHeaders()
    };

    return await fetch(`${configData.bffApiUrl}${this.energyProductSearchPath}`, init)
      .then((response) => {
        if (!response.ok) {
          if (response.status === 300) {
            throw new ResponseError(response.statusText, 'multipleMatching');
          } else if (response.status === 500) {
            throw new ResponseError(response.statusText, 'systemError');
          } else {
            throw new ResponseError(`Unable to retrieve energy products`, 'serviceNotAvailable');
          }
        }
        return response.json();
      })
      .catch((error) => {
        if (error.errorType) {
          throw new ResponseError(error.message, error.errorType);
        } else {
          throw new ResponseError(error);
        }
      });
  };
}
export const energyProductSearchApiService = new EnergyProductSearchApiService();
